module.exports = __webpack_public_path__ + "static/media/sumofus-logo-horizontal.919b3895.svg";